
/**
* @summary Classe com status que podem occorrer ao fazer uma chamada na API.
*/
const Init = "Init";
const Loading = "Loading";
const Loaded = "Loaded";
const Error = "Error";

export default {
	Init,
	Loading,
	Loaded,
	Error,
};
